import { DI } from '@microsoft/fast-foundation';
/**
 * The DI key which can be used for explicit configuration by the host application
 * @internal
 */
export const CredentialManagerConfig = DI.createInterface();
